import { Paragraph, Table } from '@zillow/constellation-10';
import { IconFileFilled } from '@zillow/constellation-icons';
import { SatelliteRenterProfileCompletenessType } from '@zg-rentals/ts-satellite-client';
import { ModalType } from '../../../../types/ModalType';
import { EXPIRED_RENTER_PROFILE } from '../../../InboxSidebar/components/ExpiredRenterProfile';
import { TooltipWrapper } from '@zg-rentals/satellite-components';
import TriggerText from '../../../TriggerText';
import type { HandleOpenModal } from '../TableContent';
import { NOT_PROVIDED } from '../TableContent';
import {
  emitRenterProfileEntryClickEvent,
  RENTER_PROFILE_ENTRY_CLICK_EVENT_TYPE_ID,
} from '../../../../constants/clickstreamEvents/multiFamilyLeadsPage';
import { useAuth } from '../../../../AuthProvider';

type Props = {
  isRenterProfileHidden: boolean;
  onRenterProfileClick: HandleOpenModal;
  renterProfileCompleteness: SatelliteRenterProfileCompletenessType;
};

const getTriggerText = (renterProfileCompleteness: SatelliteRenterProfileCompletenessType) => {
  if (renterProfileCompleteness === SatelliteRenterProfileCompletenessType.PARTIALLY_COMPLETE) {
    return 'In-progress';
  } else if (renterProfileCompleteness === SatelliteRenterProfileCompletenessType.COMPLETE) {
    return 'Complete';
  }

  return NOT_PROVIDED;
};

export default function RenterProfileTableCell({
  isRenterProfileHidden,
  onRenterProfileClick,
  renterProfileCompleteness,
}: Props) {
  const { user } = useAuth();

  const handleRenterProfileClick = () => {
    emitRenterProfileEntryClickEvent(user);
    return onRenterProfileClick(ModalType.RenterProfileModal);
  };

  const renterProfileCompletenessText = getTriggerText(renterProfileCompleteness);
  const isRenterProfileAvailable =
    renterProfileCompletenessText && renterProfileCompletenessText !== NOT_PROVIDED && !isRenterProfileHidden;

  return (
    <Table.Cell css={{ verticalAlign: 'top' }}>
      <TooltipWrapper tooltipText={EXPIRED_RENTER_PROFILE} wrapInTooltip={isRenterProfileHidden}>
        {isRenterProfileAvailable ? (
          <TriggerText
            data-eventid={RENTER_PROFILE_ENTRY_CLICK_EVENT_TYPE_ID}
            icon={<IconFileFilled />}
            onClick={handleRenterProfileClick}
          >
            {renterProfileCompletenessText}
          </TriggerText>
        ) : (
          <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>
            {NOT_PROVIDED}
          </Paragraph>
        )}
      </TooltipWrapper>
    </Table.Cell>
  );
}
